import {CIB_CABINET_ADV_DATA} from '@/core/constants/cookies';

export default ({app, query}) => {
    const isAdvData = Object.keys(query).some((key) => (key.includes('utm') || key.includes('ad_')));

    if (isAdvData) {
        app.$cookies.set(CIB_CABINET_ADV_DATA, query, {
            path: '/',
            maxAge: 60 * 60 * 24 * 7,
        });
    }
};
